import Layout from "@/layout";

const storeRouter = {
  path: "/application",
  component: Layout,
  redirect: "/application/carousel",
  name: "Application",
  meta: {
    title: "应用管理",
    icon: "clipboard"
  },
  children: [
    {
      path: "branding",
      component: () => import("@/views/application/branding/index.vue"),
      name: "branding",
      meta: { title: "品牌宣传", icon: "" }
    },
    {
      path: "carousel",
      component: () => import("@/views/application/carousel/index.vue"),
      name: "Carousel",
      meta: { title: "轮播图", icon: "" }
    },
    {
      path: "edit/:id?",
      component: () => import("@/views/application/branding/create/index"),
      name: "ArticleEdit",
      meta: {
        title: "品宣添加",
        noCache: true,
        activeMenu: `/application/branding`,
        parentPath: "/application/branding"
      },
      hidden: true
    },
    {
      path: "appmenu",
      component: () => import("@/views/application/appmenu/index.vue"),
      name: "appmenu",
      meta: { title: "小程序菜单", icon: "" }
    }
  ]
};

export default storeRouter;
